import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { AddInvolvedPartyRequest, InvolvedParty, RemoveInvolvedPartyRequest } from "@/store/site-monitor/types";
import { AxiosInstance } from "axios";

class InvolvedPartiesApi {
	private axios: AxiosInstance;
	private axiosJson: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async addInvolvedParty(request: AddInvolvedPartyRequest): Promise<void> {
		await this.axiosJson.put("/InvolvedParty/AddInvolvedParty", request);
	}

	public async removeInvolvedParty(request: RemoveInvolvedPartyRequest): Promise<void> {
		await this.axiosJson.put("/InvolvedParty/RemoveInvolvedParty", request);
	}

	public async getInvolvedPartiesForEvent(eventId: number): Promise<InvolvedParty[]> {
		const { data } = await this.axios.get(`/InvolvedParty/InvolvedPartiesForEvent/${eventId}`);
		return data;
	}

	public async anonymizeInvolvedParty(involvedPartyId: number): Promise<void> {
		await this.axios.post(`/InvolvedParty/AnonymizeInvolvedParty/${involvedPartyId}`);
	}
}

const involvedPartiesApi = new InvolvedPartiesApi();
export default involvedPartiesApi;
